import { render, staticRenderFns } from "./TrackingCategoryCreationSection.vue?vue&type=template&id=c2cfcf1e&scoped=true&"
import script from "./TrackingCategoryCreationSection.vue?vue&type=script&lang=js&"
export * from "./TrackingCategoryCreationSection.vue?vue&type=script&lang=js&"
import style0 from "./TrackingCategoryCreationSection.vue?vue&type=style&index=0&id=c2cfcf1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cfcf1e",
  null
  
)

export default component.exports